import React from 'react';
import { PageProps } from '../components/component-switcher';
// import PageGrid from "../components/page-grid";
import SectionTitle from '../components/section-title';
import { generateSectionId } from '../helpers/layout-helpers';
import ComponentSwitcher from '../components/component-switcher';

class StandardSection extends React.Component<PageProps> {
  render() {
    let className = `page-container standard-section ${this.props.type.toLowerCase()} has-children`;
    if (this.props.sideMenuTitle) {
      className += ' can-scroll-to';
    }
    return (
      <section className={className} id={generateSectionId(this.props)}>
        {this.props.mainTitle && <SectionTitle title={this.props.mainTitle} />}
        {this.props.itemChildren?.map((section: any) => (
          <ComponentSwitcher {...section} />
        ))}
      </section>
    );
  }
}

export default StandardSection;
